import {Component, inject, input} from '@angular/core';
import {SvgSpriteIcon} from '@selpia/shared/ui';
import {Router} from '@angular/router';
import {DimensionItem, Perspective} from '@selpia/shared/models';
import {OptionsState} from '@selpia/options/data-access';
import {NavigationHelper} from '@selpia/data-batch/history-access';
import {AnalyticsDirective} from '@selpia/user/tracking';

@Component({
  selector: 'lib-report-button',
  templateUrl: './report-button.component.html',
  styleUrl: './report-button.component.css',
  imports: [AnalyticsDirective],
})
export class ReportButtonComponent {
  readonly #router: Router = inject(Router);

  readonly reportPath = input.required();
  readonly perspective = input.required<Perspective>();
  readonly filterDimensions = input<DimensionItem[]>([]);
  readonly options = input<Partial<OptionsState>>({});

  getPerspectiveName() {
    return this.perspective().focusDimensionLevel.name;
  }

  // Removed getReportPath and getFilterDimensions as they directly expose fields without additional logic.
  generateReport() {
    const nextPerspective: Perspective = {...this.perspective(), filterDimensions: this.filterDimensions()};

    const queryParams = {
      ...NavigationHelper.getParamsForOptions(this.options()),
      ...NavigationHelper.getParamsForPerspective(nextPerspective),
    };

    this.#router.navigate([this.reportPath()], {queryParams});
  }

  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
